import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKotlinDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 58,
	height: 58,
	viewBox: "0 0 58 58",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5 5.00598H53L29 29.006L53 53.006H5V5.00598Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgKotlinDark);
export { ForwardRef as ReactComponent };
